export function orderStatusMap(value) {
  let status = '';

  switch (value) {
    case 0:
      status = '找司機';
      break;
    case 1:
      status = '待載客';
      break;
    case 2:
      status = '載客中';
      break;
    case 3:
      status = '待驗單';
      break;
    case 4:
      status = '完成';
      break;
    case 5:
      status = '取消';
      break;
    default:
      status = '';
  }

  return status;
}

export function deliveryMethodTableMap(value) {
  let method = '';

  switch (value) {
    case 0:
      method = '就醫';
      break;
    case 1:
      method = '社區';
      break;
    case 2:
      method = '社區';
      break;
    default:
      method = '';
  }

  return method;
}

export function deliveryMethodFormMap(value) {
  let method = null;

  switch (value) {
    case 0:
      method = '就醫接送';
      break;
    case 1:
      method = '社區式接送';
      break;
    case 2:
      method = '社區式接送(共乘)';
      break;
    default:
      method = '請選擇';
  }

  return method;
}

export function subsidyMethodTableMap(value) {
  let method = '';

  switch (value) {
    case 0:
      method = '就醫';
      break;
    case 1:
      method = '社區';
      break;
    case 2:
      method = '博愛';
      break;
    case 3:
      method = '自費';
      break;
    default:
      method = '';
  }

  return method;
}

export function subsidyMethodFormMap(value) {
  let method = '';

  switch (value) {
    case 0:
      method = '就醫補助';
      break;
    case 1:
      method = '社區式接送';
      break;
    case 2:
      method = '使用博愛卡';
      break;
    case 3:
      method = '自費';
      break;
    default:
      method = '請選擇';
  }

  return method;
}

export function verificationMethodMap(value) {
  let method = '';

  switch (value) {
    case 0:
      method = '乘客簽名';
      break;
    case 1:
      method = '掃描 QR code';
      break;
    case 2:
      method = '驗證號碼';
      break;
    case 3:
      method = '不使用補助';
      break;
    default:
      method = '--';
  }

  return method;
}

export function classMap(value) {
  let userClass = '';

  switch (value) {
    case 0:
      userClass = '一般收入戶';
      break;
    case 1:
      userClass = '中低收入戶';
      break;
    case 2:
      userClass = '低收入戶';
      break;
    default:
      userClass = '請選擇';
  }

  return userClass;
}

export function areaTypeMap(value) {
  let areaType = '';

  switch (value) {
    case 0:
      areaType = '一般地區';
      break;
    case 1:
      areaType = '次偏鄉地區';
      break;
    case 2:
      areaType = '偏鄉地區';
      break;
    default:
      areaType = '請選擇';
  }

  return areaType;
}

export function districtMap(value) {
  let district = '';

  switch (value) {
    case '新興區':
      district = '新興區';
      break;
    case '前金區':
      district = '前金區';
      break;
    case '苓雅區':
      district = '苓雅區';
      break;
    case '鹽埕區':
      district = '鹽埕區';
      break;
    case '鼓山區':
      district = '鼓山區';
      break;
    case '旗津區':
      district = '旗津區';
      break;
    case '前鎮區':
      district = '前鎮區';
      break;
    case '三民區':
      district = '三民區';
      break;
    case '楠梓區':
      district = '楠梓區';
      break;
    case '小港區':
      district = '小港區';
      break;
    case '左營區':
      district = '左營區';
      break;
    case '仁武區':
      district = '仁武區';
      break;
    case '大社區':
      district = '大社區';
      break;
    case '東沙群島':
      district = '東沙群';
      break;
    case '南沙群島':
      district = '南沙群';
      break;
    case '岡山區':
      district = '岡山區';
      break;
    case '路竹區':
      district = '路竹區';
      break;
    case '阿蓮區':
      district = '阿蓮區';
      break;
    case '田寮區':
      district = '田寮區';
      break;
    case '燕巢區':
      district = '燕巢區';
      break;
    case '橋頭區':
      district = '橋頭區';
      break;
    case '梓官區':
      district = '梓官區';
      break;
    case '彌陀區':
      district = '彌陀區';
      break;
    case '永安區':
      district = '永安區';
      break;
    case '湖內區':
      district = '湖內區';
      break;
    case '鳳山區':
      district = '鳳山區';
      break;
    case '大寮區':
      district = '大寮區';
      break;
    case '林園區':
      district = '林園區';
      break;
    case '鳥松區':
      district = '鳥松區';
      break;
    case '大樹區':
      district = '大樹區';
      break;
    case '旗山區':
      district = '旗山區';
      break;
    case '美濃區':
      district = '美濃區';
      break;
    case '六龜區':
      district = '六龜區';
      break;
    case '內門區':
      district = '內門區';
      break;
    case '杉林區':
      district = '杉林區';
      break;
    case '甲仙區':
      district = '甲仙區';
      break;
    case '桃園區':
      district = '桃園區';
      break;
    case '那瑪夏區':
      district = '那瑪夏';
      break;
    case '茂林區':
      district = '茂林區';
      break;
    case '茄萣區':
      district = '茄萣區';
      break;
    default:
      district = '請選擇';
  }

  return district;
}

export function payOwnselfProportionMap(value) {
  if (value) {
    return `${value}%`;
  } else {
    return '無';
  }
}
